// src/api/languageApi.ts

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../env';
export interface Language {
  id: number;
  name: string;
  proficiency: string;
  userId: number;
}


export const languageApi = createApi({
  reducerPath: 'languageApi',
  baseQuery: fetchBaseQuery({ baseUrl: environment.apiUrl }), // Adjust the base URL to match your backend
  tagTypes: ['Language'],
  endpoints: (builder) => ({
    getLanguagesByUserId: builder.query<Language[], number>({
      query: (userId) => `/languages/${userId}`,
      providesTags: ['Language']
    }),
    addLanguage: builder.mutation<Language, {name: string; proficiency: string; userId: number} >({
      query: ({ userId, ...rest }) => ({
        url: `/languages/${userId}`,
        method: 'POST',
        body: rest,
      }),
      invalidatesTags: ['Language']
    }),
    // Delete a language
    deleteLanguage: builder.mutation({
      query: (languageId) => ({
        url: `/languages/${languageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Language']
    }),
  }),  
});

// Export hooks for usage in functional components
export const { 
  useGetLanguagesByUserIdQuery,
  useAddLanguageMutation, 
  useDeleteLanguageMutation,
} = languageApi;
